import React from 'react'
import { useDispatch } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import {
  loadFuels,
  loadFuelStatistic,
  loadStations,
  loadTankStatistic,
} from '../../../stores/actions'
import { TankStatisticComponent } from './components'
import { FuelStatisticComponent } from './components/FuelStatisticComponent'

const Container = styled.div<{
  style: {
    isDesktopScreen: boolean
  }
}>`
  padding: 25px ${(props) => (props.style.isDesktopScreen ? 35 : 0)}px 0
    ${(props) => (props.style.isDesktopScreen ? 35 : 0)}px;
  width: 100%;
  height: 100%;
  background-color: white;
`

export const DashboardPage: React.FC = () => {
  const dispatch = useDispatch()

  const isDesktopScreen = useMediaQuery({ minWidth: 800 })

  React.useEffect(() => {
    dispatch(loadFuels())
    dispatch(loadStations())
    dispatch(loadTankStatistic())
    dispatch(loadFuelStatistic())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container style={{ isDesktopScreen }}>
      <FuelStatisticComponent />
      <TankStatisticComponent />
    </Container>
  )
}
